import PropTypes from "prop-types";

export default {
  reloadMember: PropTypes.func.isRequired,
  reloadMembership: PropTypes.func.isRequired,
  member: PropTypes.oneOfType([PropTypes.bool, PropTypes.object]).isRequired,
  membership: PropTypes.oneOfType([PropTypes.bool, PropTypes.object]).isRequired
};
